/* import __COLOCATED_TEMPLATE__ from './post-session-summary-form.hbs'; */
import { action } from '@ember/object';
import { bannerError } from 'client-portal/utils/error-handling';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './post-session-summary-form.module.scss';

export default class SiteDocumentsPostSessionSummaryForm extends Component {
  @service clientPortalTracking;
  @service currentPractice;
  @service intl;
  styles = styles;

  @action
  async nextStep() {
    try {
      await this.args.completeRequestTask.perform(this.args.model);
    } catch (err) {
      let errorTitle = this.intl.t('messages.error.documentNotSubmitted');
      this.clientPortalTracking.trackErrorOnDocumentsPage(errorTitle);
      bannerError(err, { title: errorTitle });
    }
  }
}
